import {
  wrappedGet,
  wrappedPost,
} from "../../../../../assets/js/src/general/utils";
import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store.js";

export const getBenchmarksData = async (data) =>
  new Promise((resolve) => {
    wrappedPost({
      url: "/api/dashboard/benchmarks",
      data: JSON.stringify(data),
      success: (res) => {
        resolve(res);
      },
    });
  });

export const getHeatmapData = async (data) =>
  new Promise((resolve) => {
    wrappedPost({
      url: "/api/dashboard/email_tracking",
      data: JSON.stringify(data),
      success: (res) => {
        resolve(res);
      },
    });
  });

export const getLeaderboardData = async (data) =>
  new Promise((resolve) => {
    wrappedPost({
      url: "/api/dashboard/leaderboard",
      data: JSON.stringify(data),
      success: (res) => {
        resolve(res);
      },
    });
  });

export const getLiveFeedData = async (data) =>
  new Promise((resolve) => {
    wrappedPost({
      url: "/api/activities/fill_live_feed",
      data: JSON.stringify(data),
      success: (res) => {
        resolve(res);
      },
    });
  });

export const getStatCardData = async (data) =>
  new Promise((resolve) => {
    wrappedPost({
      url: "/api/dashboard/stat_card",
      data: JSON.stringify(data),
      success: (res) => {
        resolve(res);
      },
    });
  });

export const getUsersAndGroupsData = async () =>
  Promise.all([
    new Promise((resolve, reject) => {
      wrappedGet({
        url: "/api/dashboard/users_and_groups",
        success: async (res) => {
          resolve(res);
        },
        error: (err) => {
          if (err.status === 402) {
            resolve({ users: [], groups: [] });
          } else {
            reject(new Error(`Error fetching users and groups: ${err.status}`));
          }
        },
      });
    }),
    userStore.once(),
  ]);
